import React from "react";
import DownloadReports from "../Home/DownloadReaports";
import { Helmet } from 'react-helmet';

import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>
       <Helmet>
        <title>Privacy Policy: Your Data Protection at Realistic Realtors


</title>
        <meta name="description" content="Our comprehensive privacy policy outlines how Realistic Realtors protects and handles your personal information with utmost confidentiality and security.


" />
      </Helmet>
      <h1 className="medium-heading1012 ap-head shadow-sm"> Privacy Policy</h1>

      <div className="ppp-cotnainer page-noice-bg">
        <div className="ppp-content-container">
          <h1 className="large-heading mv-heading">Privacy Policy</h1>
          <p className="small-text dv-small-desc">
            Privacy Policy is a legal document that stipulates the ways a business
            proprietor/company/entity collects the data of the party, discloses
            how and why their information will be used along with who has the
            access to it.
          </p>
          <p className="small-text dv-small-desc">
            This Privacy Policy provides you with particulars about the ways in
            which the data of the Visitor is collected, stored & used by our
            website. You are advised to read this Privacy Policy carefully. By
            visiting our website, you expressly give us consent to use & disclose
            your personal information in accordance with this Privacy Policy. If
            you do not agree to the terms of the Policy, please do not use or
            access our website.
          </p>
          <p className="small-text dv-small-desc">
            This Privacy Statement applies to RRPL website. Please note that our
            site may contain links to other sites. RRPL is not responsible for the
            privacy practices, privacy statements, or content regarding these
            other sites.
          </p>
          <div className="ppp-green-block"></div>
          <p className="small-text mv-small mt-5">
            <b>Information We Gather from You</b>
          </p>
          <p className="small-text mv-small">
            <b>Personal Information</b>
          </p>
          <p className="small-text dv-small-desc">
            We at RRPL respect the online privacy of the visitor and recognise the
            need for an appropriate protection of any personal information you
            share with us. We do not collect any personal information from a
            visitor to our site unless that visitor explicitly and intentionally
            provides it. Under no circumstances do we collect any personal data
            revealing racial or ethnic origin, political opinions, religious or
            philosophical beliefs, trade union membership, health, or sex life. If
            you are simply browsing our site, we do not gather any personal
            information about you. RRPL does not disclose the personal data of the
            visitor for any secondary purposes.
          </p>

          <p className="small-text mv-small">
            <b>Statistical Information about Your Visit</b>
          </p>
          <p className="small-text dv-small-desc">
            When you visit our site, our computers may automatically collect
            statistics about your visit. This information does not identify you
            personally, but rather about a visit to our site. We may monitor
            statistics such as how many people visit our site, the user’s IP
            address, which pages people visit, from which domains our visitors
            come and which browsers people use. We use these statistics about your
            visit for aggregation purposes only. These statistics are used to help
            us improve the performance of our Web site.
          </p>
          <p className="small-text mv-small">
            <b>Sending you responses and updates</b>
          </p>
          <p className="small-text dv-small-desc">
            We generally respond to any E-mail questions, requests for product or
            service information, and other inquiries that we receive. We may also
            retain this correspondence to improve our products, services, and Web
            site, and for other disclosed purposes. Frequently we retain contact
            information for communication to enable us to send individuals updates
            or other important information about our services and products.
          </p>

          <p className="small-text mv-small">
            <b>Consent</b>
          </p>
          <p className="small-text dv-small-desc">
            By visiting our website, you consent to our Privacy Policy including
            but not limited to your consent for sharing your information as per
            this Privacy Policy. This Policy may change from time to time.
          </p>
          <p className="small-text mv-small">
            <b>Changes to our Privacy Policy</b>
          </p>
          <p className="small-text dv-small-desc">
            You may access a current version of the Privacy Policy from the RRPL
            website. We may update our Privacy Policy from time to time. You are
            advised to review this Privacy Policy periodically for any changes.
            Changes to this Privacy Policy are effective when they are posted on
            this page.
          </p>
          <p className="small-text mv-small">
            <b>Contact Us</b>
          </p>
          <p className="small-text dv-small-desc">
            If you have any query, requests or grievance with regard to this
            Privacy Policy, please contact us at 1800-123-0396.
          </p>
        </div>
      </div>
    </>

  );
};

export default PrivacyPolicy;
